import type { DashboardUserProfile } from '@services/firebase'
import { normalizeDashboardLanguageValue } from '@features/dashboard/store/dashboard-state'

export {
  clampPercent,
  getCurrentWeekBounds,
  getDailyGoalTargetSeconds,
  getDailyStudiedSeconds,
  getDisplayMinutesFromSeconds,
  getDisplayMinutesFromSecondsMinOne,
  getLearningActivityMetrics,
  getStudiedSecondsBetween,
  getTodayLearningMinutes,
  getWeekdayValue,
  getWeeklyGoalProgressPercent,
  getWeeklyGoalTargetSeconds,
  getWeeklyStudiedSeconds,
  getWeeklyStudiedSecondsForWeekday,
} from '@shared/learning/profile-activity'
export type {
  LearningActivityMetrics,
  LearningActivityProfileSource,
  LearningActivityRecord,
  WeekBounds,
} from '@shared/learning/profile-activity'

export function getProfileFullName(profile: DashboardUserProfile | null) {
  if (!profile) {
    return 'Learner'
  }

  const parts = [
    profile.firstname,
    profile.middlename,
    profile.lastname,
  ].filter((value): value is string => Boolean(value && value.trim()))

  return parts.length > 0 ? parts.join(' ') : 'Learner'
}

export function normalizeDashboardLanguage(locale: string) {
  return normalizeDashboardLanguageValue(locale)
}
